// ObjectDetector.js
var ObjectDetector = pc.createScript('objectDetector');

ObjectDetector.prototype.initialize = function() {
    this.entity.collision.on('collisionstart', this.onCollisionStart, this);
};

ObjectDetector.prototype.onCollisionStart = function (result) {
    var refEntity = result.other;
    refEntity.rigidbody.teleport(refEntity.parent.getPosition().x, refEntity.parent.getPosition().y, refEntity.parent.getPosition().z);
};

